import { z } from "zod";
/**
 * User token payload (embedded in JWT)
 */
export const userTokenPayloadSchema = z.object({
    type: z.literal("user"),
    assistant_id: z.string().uuid(),
    user_id: z.string(),
    session_id: z.string(), // Can be UUID (existing) or pending_* (lazy)
    is_pending_session: z.boolean(),
    iat: z.number().optional(),
    exp: z.number().optional(),
});
/**
 * Admin token payload (embedded in JWT)
 */
export const adminTokenPayloadSchema = z.object({
    type: z.literal("admin"),
    assistant_id: z.string().uuid(),
    session_id: z.string().uuid(),
    admin_id: z.string(),
    admin_name: z.string(),
    iat: z.number().optional(),
    exp: z.number().optional(),
});
/**
 * User token generation request
 * Note: user_id is required when session_id is provided (for security)
 */
export const userTokenRequestSchema = z
    .object({
    assistant_id: z.string().uuid(),
    user_id: z.string().optional(), // Optional for new sessions - will generate if not provided
    session_id: z.string().uuid().optional(), // Optional - lazy creation if not provided
})
    .refine((data) => {
    // If session_id is provided, user_id must also be provided
    if (data.session_id && !data.user_id) {
        return false;
    }
    return true;
}, {
    message: "user_id is required when rejoining an existing session",
    path: ["user_id"],
});
/**
 * Admin token generation request
 */
export const adminTokenRequestSchema = z.object({
    assistant_id: z.string().uuid(),
    session_id: z.string().uuid(),
    admin_id: z.string(),
    admin_name: z.string(),
});
